// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3MzOf","title":"Info_title__29B9G","selects":"Info_selects__3qzY_","requiredAsterisk":"Info_requiredAsterisk__tBJex"};